<!-- Close button OUTSIDE pdfContent -->
<div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
  <h2 class="title px-6 py-4" fxFlex="auto">
    Digital service acceptance form
  </h2>
  <button
    class="text-secondary"
    mat-dialog-close
    mat-icon-button
    type="button"
    matTooltip="Close"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- Content to be included in the PDF -->
<div #pdfContent>
  <mat-divider></mat-divider>

  <mat-dialog-content fxLayout="column" class=" px-8 py-4">
    <div
      *ngIf="isLoading"
      fxLayoutAlign="center center"
      class="centered-content"
    >
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>

    <div *ngIf="!isLoading" class="content-box border-4 rounded-lg p-6">
      <p>
        I consent to electronic service of medicolegal reports in lieu of
        physical mail by the United States Postal Service. This includes reports
        for PQMEs (Panel Qualified Medical Evaluations), AMEs (Agreed Medical
        Evaluations), and other reports.
      </p>

      <p class="mt-3">
        <strong>Electronic service email address:</strong> {{ this.email }}
      </p>

      <p class="mt-3">
        If my email address changes, or I no longer wish to accept electronic
        service, I will notify OrthoLegal immediately at
        <a href="mailto:info&#64;ortholegalgroup.com"
          >info&#64;ortholegalgroup.com</a
        >.
      </p>

      <div *ngIf="isManualAcceptance" class="mt-4 manual-acceptance">
        <p *ngIf="identityKind === 'attorney'"><strong>Attorney Name:</strong> {{ attorneyName }}</p>
        <p *ngIf="identityKind === 'attorney'" class="mt-2"><strong>Firm Name:</strong> {{ firmName }}</p>
        <p *ngIf="identityKind === 'insurance'"><strong>Insurance Company Name:</strong> {{ insuranceCompanyName }}</p>
        <p *ngIf="identityKind === 'insurance'" class="mt-2"><strong>Adjuster Name:</strong> {{ adjusterName }}</p>
        <p [class.mt-2]="identityKind !== 'name'"><strong>Digital Service Status:</strong> Accepted</p>
        <p class="mt-2"><strong>Acceptance Method:</strong> Manual – External Form</p>
        <p class="mt-2">
          <strong>External Acceptance Form:</strong>
          <a
            *ngIf="externalAcceptanceUrl"
            [href]="externalAcceptanceUrl"
            target="_blank"
            rel="noopener noreferrer"
          >View Acceptance Form</a>
        </p>
        <p class="mt-2"><strong>Recorded By:</strong> {{ recordedByName }}</p>
        <p class="mt-2">
          <strong>Recorded On:</strong>
          {{ acceptanceDate ? (acceptanceDate | date : "MM/dd/yyyy, h:mm a") : "" }}
        </p>
      </div>

      <div *ngIf="!isManualAcceptance" fxLayout="row" fxLayoutGap="8px" class="mt-4 gap-x-10">
        <div fxLayout="column" fxLayoutAlign="center start">
          <img
            *ngIf="sign"
            [src]="FileURL + this.sign"
            alt="Signature"
            style="max-height: 150px; max-width: 150px"
            class="py-3"
          />
          <span *ngIf="!sign" class="py-3 text-secondary">No signature on file</span>
          <span><strong>Signature</strong></span>
        </div>

        <ng-container *ngIf="identityKind === 'attorney'">
          <div fxLayout="column" fxLayoutAlign="center start">
            <span fxFlex class="py-3">{{ attorneyName }}</span>
            <span><strong>Attorney Name</strong></span>
          </div>
          <div fxLayout="column" fxLayoutAlign="center start">
            <span fxFlex class="py-3">{{ firmName }}</span>
            <span><strong>Firm Name</strong></span>
          </div>
        </ng-container>

        <ng-container *ngIf="identityKind === 'insurance'">
          <div fxLayout="column" fxLayoutAlign="center start">
            <span fxFlex class="py-3">{{ insuranceCompanyName }}</span>
            <span><strong>Insurance Company Name</strong></span>
          </div>
          <div fxLayout="column" fxLayoutAlign="center start">
            <span fxFlex class="py-3">{{ adjusterName }}</span>
            <span><strong>Adjuster Name</strong></span>
          </div>
        </ng-container>

        <div *ngIf="identityKind === 'name'" fxLayout="column" fxLayoutAlign="center start">
          <span fxFlex class="py-3">{{ this.fullName }}</span>
          <span><strong>Name</strong></span>
        </div>

        <div fxLayout="column" fxLayoutAlign="center start">
          <span fxFlex class="py-3">{{
            acceptanceDate ? (acceptanceDate | date : "MM/dd/yyyy" : "UTC") : ""
          }}</span>
          <span><strong>Date</strong></span>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>

<!-- Dialog actions, also not included in PDF -->
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button" matTooltip="Cancel">
    Cancel
  </button>
  <button
    mat-button
    (click)="downloadPDF()"
    type="button"
    matTooltip="Download as PDF"
  >
    Download PDF
  </button>
</mat-dialog-actions>
